export const numberFormatter = new Intl.NumberFormat('pt-BR', { style: 'decimal' });
